import { render, staticRenderFns } from "./ticketDetailPC.vue?vue&type=template&id=2f2c5430&scoped=true"
import script from "./ticketDetailPC.vue?vue&type=script&lang=js"
export * from "./ticketDetailPC.vue?vue&type=script&lang=js"
import style0 from "./ticketDetailPC.vue?vue&type=style&index=0&id=2f2c5430&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c5430",
  null
  
)

export default component.exports